import React from 'react'
import type { AuthContextProps, Session } from 'types/auth'

export const AuthContextDefaultValue: AuthContextProps = {
  bcksUserSession: null,
  userHasNoAccess: false,
  setBcksUserSession: (value: Session) => {},
  logout: () => ({}),
}

export const AuthContext = React.createContext<AuthContextProps>(
  AuthContextDefaultValue
)
AuthContext.displayName = 'AuthContext'
